module.exports = __webpack_public_path__ + "img/ipcoaching-01.f998fd45.svg";